import React from "react";
import EmrManagement from "../../components/Super Admin/EMR Management/EmrManagement";

const EmrManagementPage: React.FC = () => {
  return (
    <>
      <EmrManagement />
    </>
  );
};

export default EmrManagementPage;
